<template>
  <component :is="templateData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="templateData === undefined">
      <h4 class="alert-heading">獲取模版數據時出錯</h4>
      <div class="alert-body">
        找不到相關模版記錄。請查看
        <b-link class="alert-link" :to="{ name: 'pdf-templates-list' }">
          模版列表
        </b-link>
      </div>
    </b-alert>
    <!-- :quotation-options="quotationOptions"
      :template-type-options="templateTypeOptions"
      :customer-options="customerOptions"
      :product-options="productOptions"
      :product-unit-options="productUnitOptions"
      :template-remark-options="templateRemarkOptions" 
      
      :project-options="projectOptions"-->
    <template-edit-tab-information
      v-if="templateData"
    
      :template-data="templateData"
      @refetch-data="refetchData"
      class="p-sm-2"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import pdfTemplateStoreModule from "../pdfTemplateStoreModule";
import templateEditTabInformation from "./pdfTemplateEditTabInformation.vue";
import axiosIns from "@/libs/axios";
import {getDateTime} from "@/libs/helper";

export default {
  components: {
    templateEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const templateData = ref({ 
          id: 0,
          template_name: null,
          logo_image_path: null,
          stamp_image_path: null,
          company_info: null,
          bank_info: null,
          address: null,
          website: null,
          phone: null,
          email: null,
          fax: null,
      }
   );
    const template = {
          id: 0,
          template_name: null,
          logo_image_path: null,
          stamp_image_path: null,
          company_info: null,
          bank_info: null,
          address: null,
          website: null,
          phone: null,
          email: null,
          fax: null,
    };

    const template_APP_STORE_MODULE_NAME = "template";

    if (!store.hasModule(template_APP_STORE_MODULE_NAME))
      store.registerModule(template_APP_STORE_MODULE_NAME, pdfTemplateStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(template_APP_STORE_MODULE_NAME))
        store.unregisterModule(template_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "pdf-templates-create") {
          templateData.value = template;
      } else {
        store
          .dispatch("template/fetchTemplate", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            templateData.value = response.data.template;
          })
          .catch((error) => {
            console.log("error when fetching template", error);
            if (error.response.status === 404) {
              templateData.value = undefined;
            }
          });
      }
    };




    onMounted(() => {
      refetchData();
    });

    return {
      refetchData,
      templateData
    };
  },
};
</script>
